// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/module/iconProfile/iconProfileCtrl.js#1 $
'use strict';

/**
* @ngdoc directive
* @name tcApp.directive:tciconProfile
* @element ANY
* @description
* # tciconProfile
* Adds a iconProfile menu to components, charts etc
*/
angular.module('tc.iconProfile')
.controller('IconProfileCtrl', function($mdSidenav, $scope, $rootScope, GlobalService) {
	var onInit = function() {
		$scope.viewModel = {
			listRowIndex: (angular.isDefined($scope.tcListRowIndex) ? ($scope.tcListRowIndex) : ''),
			isLoading: true,
			minimumIconsToWrap: 3,
		};
		$scope.globalStrings = GlobalService.getGlobalStrings();
		
		$scope.$watch('tcIconProfile.icons', function(newValue) {
			if (angular.isArray(newValue)) {
				$scope.viewModel.isLoading = false;
			}
		});
	};

	$scope.iconClickHandler = function($event, currentIcon) {
		if (currentIcon.spacer) return;
		var listRowData = {};
		var messageItem;
		$event.stopPropagation();
		listRowData['_actionIcons'] = $scope.tcIconProfile.icons;
		if ($scope.tcListRow) {
			// Pass current action Header values from tcListRow
			angular.forEach($scope.tcListRow['_actionHeaders'], function(actionHeader, actionHeaderIndex, actionHeaders) {
				var itemName = actionHeader.name;
				var responsiveDisplayForActionMenu = actionHeader.responsiveDisplayForActionMenu;
				if (angular.isDefined($scope.tcListRow[itemName])) {
					actionHeaders[actionHeaderIndex] = $scope.tcListRow[itemName];
					actionHeaders[actionHeaderIndex].name = itemName;
					if (angular.isDefined(responsiveDisplayForActionMenu)) {
						actionHeaders[actionHeaderIndex].responsiveDisplayForActionMenu = responsiveDisplayForActionMenu;
					}
				}
			});
			listRowData['_actionHeaders'] = $scope.tcListRow['_actionHeaders'];
			if (angular.isFunction($scope.tcSelectMessageFunc)) {
				messageItem = $scope.tcSelectMessageFunc($scope.tcListRow);
			}
		} else if (angular.isDefined($scope.tcIconProfile.dataHeaders)) {
			// Floorplan data header, and messages
			listRowData['_actionHeaders'] = $scope.tcIconProfile.dataHeaders;
			if (angular.isFunction($scope.tcIconProfile.tcSelectMessageFunc)) {
				messageItem = $scope.tcIconProfile.tcSelectMessageFunc($scope.tcIconProfile.tcSelectMessageObject);
			}
		}
		var actionMenuData = {
			listRow: listRowData,
			currentIcon: currentIcon,
			actionMenusOff: true,
			triggeringElement: $event.currentTarget
		};
		if (messageItem) actionMenuData.messages = [messageItem];
		
		// Initialise viewModel for Icon panel
		var currentIconCode = currentIcon.code;
		// rebuild the URL for the current Icon - if it is infoLink
		if (currentIcon.isInfoLink) {
			
			// "in" list changes not supported
			if (!$scope.tcListRow) {
				// e.g. epr_InfoLink_tcIconUrlHandler 
				if (angular.isFunction($scope.tcIconUrlHandler)) {	
					var cpyIcon = angular.copy(currentIcon);
					var newUrl = $scope.tcIconUrlHandler({icon: cpyIcon});
					
					// empty return means unchanged
					if (angular.isDefined(newUrl)) {
						if (newUrl != '') currentIcon.linkUrl = newUrl;
					}
				}
			}
		}
		var viewModel = {
			expandedGroups: {}
		};
		viewModel.expandedGroups[currentIconCode] = true;
		
		$mdSidenav('actionMenu').open()
			.then(function() {
				GlobalService.onModalToggle(true);
				$rootScope.$broadcast('System:focusIconInActionMenu', currentIconCode);
			});
		$rootScope.$broadcast('System:updateActionMenu', actionMenuData, viewModel);
	};
	
	onInit();
});
